import { useEffect, useMemo, useState } from "react";

import { PanesContainer, useNotionDatabase } from "dev";
import { BlurredBackground } from "ui";

import StatusScreen from "../[uuid]";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus, Status, Substatus } from "@/src/types";

export default function FullExamples() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  const [deliveryStatuses, setDeliveryStatuses] = useState<DeliveryStatus[]>(
    []
  );

  const data = useMemo(() => {
    return db
      ?.map((r) => ({
        uuid: r["Order UUID"],
        tstamp: r["Order Timestamp"],
        status: r["Status"] as Status,
        substatus: r["Sub-status"] as Substatus<Status>,
      }))
      .filter((r) => r.uuid && r.tstamp);
  }, [db]);

  useEffect(() => {
    const promises = data?.map(fetchDeliveryStatus);
    if (!promises) return;
    Promise.all(promises).then(setDeliveryStatuses);
  }, [data]);

  const nonEmptyOrders = deliveryStatuses.filter((d) => d.order !== null);

  return (
    <PanesContainer
      items={nonEmptyOrders}
      expectedCount={data?.length}
      renderItem={(deliveryStatus, index) => (
        <MockDeliveryStatusProvider deliveryStatus={deliveryStatus} key={index}>
          <BlurredBackground>
            <StatusScreen />
          </BlurredBackground>
        </MockDeliveryStatusProvider>
      )}
    />
  );
}
